import CertificateIcon from './CertificateIcon'

export default CertificateIcon
